import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    query: "",
    results: [],
    open: false,
    activeIndex: -1, // keyboard navigation
  },
  reducers: {
    setQuery: (s, a) => {
      s.query = a.payload;
    },
    setResults: (s, a) => {
      s.results = a.payload || [];
    },
    openSearch: (s) => {
      s.open = true;
    },
    closeSearch: (s) => {
      s.open = false;
      s.activeIndex = -1;
      s.query = "";
      s.results = [];
    },
    setActiveIndex: (s, a) => {
      s.activeIndex = a.payload;
    },
  },
});

export const { setQuery, setResults, openSearch, closeSearch, setActiveIndex } =
  searchSlice.actions;

export default searchSlice.reducer;
